import Table from './Table'
import Toolbar from './Toolbar'
import React, { useState, useLayoutEffect } from 'react'
import { requestSocialBadgeListPromise } from 'api/SocialBadge'

const FilterList = props => {
  const [data, setData] = useState([])

  useLayoutEffect(() => {
    requestSocialBadgeListPromise().then(data => setData(data))
  }, [])


  return (
    <div className={'root'}>
      <div className={'content'}>
        <Toolbar {...props} />
        <br />
        <Table data={data} {...props} />
      </div>
    </div>
  )
}

export default FilterList
